import React, { Component } from "react";
import { Link } from "react-router-dom";
import { isUserAuthenticated, getLoggedInUser } from "../../helpers/authUtils";

class Navbar extends Component {
  render() {
    const { showLogin, showMenuLine, isRead } = this.props;
    const isAuthTokenValid = isUserAuthenticated();
    const member = getLoggedInUser();
    return (
      <nav className="colorlib-nav" role="navigation">
        <div className="menu" style={(showMenuLine) && {borderBottom: "1px solid #CBCBCB"}}>
          <div className="container">
            <div className="row">
            <div className="col-xs-2">
            <div className="col-xs-2"> <Link to="/members"><img src="/members/img/e_3.png" width="90px" alt="" /></Link> </div>
            </div>
            {(isAuthTokenValid) && (
            <div className="col-xs-10 dropdown text-right">
              <button className="btn btn-secondary dropdown-toggle" type="button" id="dropdownMenuButton1" data-bs-toggle="dropdown" aria-expanded="false">
                <svg xmlns="http://www.w3.org/2000/svg" width="30" height="30" viewBox="0 0 256 256">
                    <path fill="#949494" d="M230.92 212c-15.23-26.33-38.7-45.21-66.09-54.16a72 72 0 1 0-73.66 0c-27.39 8.94-50.86 27.82-66.09 54.16a8 8 0 1 0 13.85 8c18.84-32.56 52.14-52 89.07-52s70.23 19.44 89.07 52a8 8 0 1 0 13.85-8ZM72 96a56 56 0 1 1 56 56a56.06 56.06 0 0 1-56-56Z"/>
                </svg>
                <br/>{member.memberName}
              </button>
              <ul className="dropdown-menu" aria-labelledby="dropdownMenuButton1">
              <li><Link className="dropdown-item" to="/members/account">個人資訊</Link></li>
              <li><Link className="dropdown-item" to="/members/bind">遊戲綁定</Link></li>
              <li><Link className="dropdown-item" to="/members/order_list">交易紀錄</Link></li>
              <li><Link className="dropdown-item" to="/members/user_info">會員訊息{isRead>0 && (<span className="badge" style={{backgroundColor: "#F6490D"}}>{isRead}</span>)}</Link></li>
              <li><Link className="dropdown-item" to="/members/logout">登出</Link></li>
              </ul>
            </div>
            )}
            {(!isAuthTokenValid) && (showLogin) && (
            <div className="col-xs-10 text-right menu-1">
              <ul>
              <li><Link to="/members/login" style={{top: "7px"}}>登入</Link></li>
              </ul>
            </div>
            )}
            </div>
          </div>
        </div>
      </nav>
    );
  }
}

export default Navbar;
